import {
  ATTENDANCE_OFFICE_LIST,
  LOCATION_TYPE,
  ATTENDANCE_SITE_LIST,
} from "./type";

const initalState = {
  attendanceData: null,
  attendanceOfficeList: null,
  attendanceSiteList: null,
};

const attendanceReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_TYPE:
      return {
        ...state,
        attendanceData: payload,
      };
    case ATTENDANCE_OFFICE_LIST:
      return {
        ...state,
        attendanceOfficeList: payload,
      };
    case ATTENDANCE_SITE_LIST:
      return {
        ...state,
        attendanceSiteList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default attendanceReducer;
